module.exports = __webpack_public_path__ + "static/media/privacy-main.42082ce4.svg";